import { render, staticRenderFns } from "./Aggregate_statistics.vue?vue&type=template&id=4e8ff25c"
import script from "./Aggregate_statistics.vue?vue&type=script&lang=js"
export * from "./Aggregate_statistics.vue?vue&type=script&lang=js"
import style0 from "./Aggregate_statistics.vue?vue&type=style&index=0&id=4e8ff25c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports